import { useQuery } from 'react-query';
import { getUserProfileService } from '../redux/services/userService';

const useHook = (userId: string) => {
  return useQuery(['publicProfile', userId], async () => {
    const result = await getUserProfileService(userId);
    return result;
  });
};

export default useHook;
